export const getters = {
  systemTruckattendances: state => state.truckattendances,
  Truckattendance: state => state.systemTruckattendance
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckattendances/getters.js